module.exports = __webpack_public_path__ + "img/1_bronze.97a96696.svg";